<template>
    <form
        action="/profil/user/password"
        method="POST"
        role="form"
        @submit.prevent="submit"
        novalidate
    >
        <section>
            <form-input-type-password
                name="old_password"
                :label="__('Existing password')"
                :errors="errors.old_password"
                required
            ></form-input-type-password>

            <form-input-type-password
                name="new_password"
                :label="__('New password')"
                :errors="errors.new_password"
                :note="__('The password must contain at least 10 characters and at least one upper and one lower case letter.')"
                required
            ></form-input-type-password>

            <form-input-type-password
                name="new_password_confirmation"
                :label="__('Re-enter new password')"
                :errors="errors.new_password_confirmation"
                required
            ></form-input-type-password>
        </section>

        <div class="button-group">
            <VButton :label="__('Save changes')" type="submit" size="lg" position="center" />
        </div>
    </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            errors: {}
        }
    },
    mounted() {
        $(() => {
            $('.fade-in').animate({ opacity: 1 }, 300)

            $('.item-pw').addClass('active')
        })
    },
    methods: {
        submit() {
            const data = {}

            // serialize form data
            $(this.$el)
                .serializeArray()
                .forEach(({ name, value }) => {
                    data[name] = value
                })

            axios
                .post('profil/user/password', data)
                .then(async(r) => {
                    window.location.reload()
                })
                .catch((e) => {
                    this.errors = e.response.data.errors
                    Vuemit.fire('Button--sending-failed', true)
                })
        }
    }
}
</script>
